module.exports = __webpack_public_path__ + "img/primary-51.964f78bb.png";